<template>
   <vue-final-modal
      v-model="notificationMailBody" 
      classes="modal-container"
      content-class="notification-mail-body-modal-content"
      @before-open="beforeOpen()"
      :click-to-close="false"
      drag-selector=".drug-area"
      :drag="true"
      >
            <!--
      @click-outside="$emit('cancel')"
            -->
      <button 
         id="prime"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="$emit('cancel')"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white row row-cols-auto">
         <card-rectangle :rectangleCard="cardType" class="col mt-1"/>
         <div class="col pe-1">Texto Complementario del Mail</div>
      </span>
      <div class="notification-mail-body p-0 mt-1 border-top border-bottom">
         <div class="container p-1">
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('final').focus()"></div>
            <!--
            <pre>{{ v310Object }}</pre>
            -->
            <textarea v-model="bodyMail" 
               class="ta-class p-1 border"
               :rows="5"
               :tabindex="tabIndexNumber(3)"
               ></textarea>
         </div>
      </div>
      <div class="row p-0 justify-content-between mx-0">
         <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
         <div class="d-flex justify-content-end pt-2 px-0 col-10">
            <div v-if="extensionApp == 'MNTF'" class="form-check pe-3 pt-1">
               <input class="form-check-input" type="checkbox" value="" id="checkInfo" @change="setIfIsInfo">
               <label class="form-check-label tx-cl-white" for="checkInfo">
                  Mail Informativo
               </label>
            </div>
            <button type="button" 
                  :tabindex="tabIndexNumber(4)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="saveDraftBody(true)"
                  >
               Ver Mail
            </button>
            <button type="button" 
                  id="final"
                  :tabindex="tabIndexNumber(5)" 
                  class="btn btn-outline-light btn-sm me-1" 
                  @click="saveDraftBody(false)"
                  >
               Salir
            </button>
            <div :tabindex="tabIndexNumber(6)" onfocus="document.getElementById('prime').focus()"></div>
         </div>
      </div>
   </vue-final-modal>
   <!--
      {{currentExtensionApp}}
   <show-mail v-if="showMail"
      :dataFromCard="oDataFromCard"
      @cancel="showMail = false"
      />
   -->
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed } from 'vue';
import { useStore } from 'vuex'

import WspService from '../../workSpace.service';

import UserCircle from '../../../../components/UserCircle.vue';
import CardRectangle from '../CardRectangle.vue';

//import ShowMail from './ShowMail.vue';
export default {

   components: {
      UserCircle,
      VueFinalModal,
      CardRectangle,
      //ShowMail
   },

   props: {
      //dataFromCard: Object,
      cardType: Object,
      extensionApp: String
      //contentId: Number
   },

   emits: [ 'cancel', 'update' ],

   setup( props, { emit }) {
   //setup( props ) {

      const initialTabIndex = ref(150)
      const notificationMailBody = ref(true)
      const myCircle = ref({})
      const store = useStore()

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      //const bodyMail = ref(store.state.wspace.updateDraftNotification)
      const bodyMail = ref('')
      const currentExtensionApp = ref( props.extensionApp )

      function beforeOpen() {
         
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })
      }

      function saveDraftBody( show ) {
         /*
         if ( show ) {
            store.dispatch("wspace/updateDraftNotification", bodyMail.value )
            oDataFromCard.value = props.dataFromCard
            oDataFromCard.value.cardTypeId = props.cardType.id
            oDataFromCard.value.bodyMail = bodyMail.value
            nextTick(() => { showMail.value = true })
            //showMail.value = true
         }
         */
         if ( show ) {
            store.dispatch(
               "wspace/updateDraftNotification", 
               //bodyMail.value 
               bodyMail.value.replace(/\n|\r/gi, '<br/>')
            )
            //emit( 'update' )
            emit( 'update', currentExtensionApp.value )
         } else {
            emit( 'cancel' )
         }
      }

      function setIfIsInfo( event ) {
         currentExtensionApp.value = props.extensionApp
         if ( event.target.checked ) {
            currentExtensionApp.value = 'MINF'
         }
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      
      return {
         beforeOpen, bodyMail,
         currentExtensionApp,
         myCircle,
         notificationMailBody,
         //oDataFromCard,
         saveDraftBody, //showMail,
         setIfIsInfo,
         tabIndexNumber
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.notification-mail-body-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 300px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.notification-mail-body {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.tj-foot-cell {
   cursor: pointer;
}
.tj-foot-cell:hover {
   background-color: darkgrey;
}
.ttl {
   color: darkslategray;
}
.ta-class {
   width: 330px;
   border-radius: 10px;
}
</style>
